
const pieConfig = {
  data: [],
  color: [],
  angleField: "value",
  colorField: "type",
  innerRadius: 0,
  label: {
    text: ({ percent }) => {

      return `${percent > 0 ? percent.toFixed(2):0}%`;
    },
    style: {
      fontWeight: 'bold',
    },
  },
  legend: {
    color: {
      title: false,
      position: 'bottom',
      rowPadding: 5,
    },
  },
  tooltip: {
    items: [
      {
        channel: "color",
        name:"",
      },
      {
        channel: "y0",
        name:'Number:',
        valueFormatter: (val) => `${val}`,
      },
     ],
   },
};

const doughnutConfig = {
  data: [],
  color: [],
  angleField: "value",
  colorField: "type",
  radius: 1,
  innerRadius: 0.6,
  label: {
    text: 'value',
    transform: [{ type: 'contrastReverse' }],
    style: {
      fontWeight: 'bold',
    },
  },
  legend: {
    color: {
      title: false,
      position: 'bottom',
      rowPadding: 5,
    },
  },
  annotations: [
    {
      type: 'text',
      style: {
        text: '',
        x: '50%',
        y: '50%',
        textAlign: 'center',
        fontSize: 40,
        fontStyle: 'bold',
      },
    },
  ],
};

const columnConfig = {
  data: [],
  color: [],
  legend: false,
  xField: "type",
  yField: "value",
  // colorField: 'value',
  label: {
    text: 'value',
    position: 'inside',
    transform: [{ type: 'contrastReverse' }],
  },
  axis: {
    x: {
      title: "",
      style: {
        titleFill: 'black'
      }
    },
    y: {
      title: "",
      style: {
        titleFill: 'black'
      }
    }
  },
};

const stackedBar = {
  data: [],
  color: [],
  colorField: 'type',
  xField: "",
  yField: "",
  seriesField: "",
  minColumnWidth: 10,
  // maxColumnWidth: 65,
  maxColumnWidth: 180,
  legend: {
    layout: "horizontal",
    position: "bottom",
  },
  label: {
    text: 'value',
    position: 'inside'
  },
  xAxis: {
    title: {
      text: "",
    },
  },
  yAxis: {
    title: {
      text: "",
    },
  },
};

const groupColumnConfig = {
  data: [],
  color: [],
  xField: '',
  yField: 'value',
  stack: true,
  colorField: 'type',
  label: {
    text: 'value',
    position: 'inside',
    transform: [{ type: 'contrastReverse' }],
  },
  legend: {
    color: {
      title: false,
      position: 'bottom',
      rowPadding: 5,
    },
  },
  axis: {
    x: {
      title: "",
      style: {
        titleFill: 'black'
      }
    },
    y: {
      title: '',
      style: {
        titleFill: 'black'
      }
    }
  },
}

const groupBar = {
  data: [],
  color: [],
  group: true,
  xField: "",
  yField: "",
  colorField: "",
  minColumnWidth: 35,
  maxColumnWidth: 65,
  // width: "80%",
  legend: {
    layout: "horizontal",
    position: "bottom",
  },
};

const dualAxes = {
  xField: 'year',
  children: [
    {
      data: [],
      type: 'interval',
      yField: 'value',
      stack: true,
      colorField: 'type',
      style: { maxWidth: 80 },
      scale: { y: { domainMax: 1200 } },
      interaction: { elementHighlightByColor: { background: true } },
    },
    {
      data: [],
      type: 'line',
      yField: 'Retention % (end of year)',
      colorField: () => 'Retention % (end of year)',
      style: { lineWidth: 2 },
      axis: { y: { position: 'right' } },
      interaction: {
        tooltip: {
          crosshairs: false,
          marker: false,
        },
      },
      legend: {
        color: {
          title: false,
          position: 'bottom',
          rowPadding: 5,
        },
      },
    },
  ],
}

const funnelChart = {
  data: [],
  color: [
    "#3f81af",
    "#37948e",
    "#95ba60",
    "#e8d23c",
    "#f36523",
    "#9d405f",
    "#487386",
    "#2b8a84",
    "#8db05c",
  ],
  xField: "type",
  yField: "value",
  label: {
    text: (d) => `${d.type}\n${d.value}`,
    transform: [{ type: 'contrastReverse' }],
  },
  legend: {
    color: {
      title: false,
      position: 'bottom',
      rowPadding: 5,
    },
  },
}

const heatMapChart = {
  data: [],
  color: [],
  xField: "type",
  yField: "group",
  colorField: 'type',
  mark: 'cell',
  style: { inset: 0.5 },
  tooltip: {
    field: 'value',
  },
  label: {
    text: 'value',
    position: 'inside',
    transform: [{ type: 'contrastReverse' }],
  },
  axis: {
    x: {
      title: '',
      style: {
        titleFill: 'black'
      },
      labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
    },
    y: {
      title: '',
      style: {
        titleFill: 'black'
      }
    }
  },
};

const stackedAreaChart = {
  data: [],
  color: [],
  xField: 'group',
  yField: 'value',
  colorField: 'type',
  shapeField: 'smooth',
  stack: {
    orderBy: 'maxIndex',
    reverse: true,
  },
  label: {
    text: 'value',
    position: 'inside',
    transform: [{ type: 'contrastReverse' }],
  },
  axis: {
    x: {
      title: "",
      style: {
        titleFill: 'black'
      }
    },
    y: {
      title: "Number of projects",
      style: {
        titleFill: 'black'
      }
    }
  },
  legend: {
    color: {
      title: false,
      position: 'bottom',
      rowPadding: 5,
    },
  }
}

const barChart = {
  data: [],
  color: [],
  xField: "",
  yField: "",
  colorField: 'value',
  legend: false,
  label: {
    text: 'value',
    transform: [{ type: 'contrastReverse' }],
    style: {
      fontWeight: 'bold',
    },
    position: 'inside',
  },
  axis: {
    x: {
      title: "",
      style: {
        titleFill: 'black'
      }
    },
    y: {
      title: "",
      style: {
        titleFill: 'black'
      }
    }
  },
}
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  pie: pieConfig,
  doughnut: doughnutConfig,
  column: columnConfig,
  groupCol: groupColumnConfig,
  stacked: stackedBar,
  grouped: groupBar,
  dual: dualAxes,
  funnel: funnelChart,
  stackedArea: stackedAreaChart,
  heat: heatMapChart,
  bar: barChart,
};
